import React from "react";
import "../styles/notifications.css";

function Notifications() {
  return (
    <div className="notifications">
      <h2>Notifications</h2>
      You have no new notifications.
    </div>
  );
}

export default Notifications;
